module.exports = __webpack_public_path__ + "img/ic_directions.ef5e3328.svg";